module.exports = __webpack_public_path__ + "img/02.68cd9d45.png";